export enum Environment {
  DEMO = 'demo',
  STAGING = 'staging',
  PRODUCTION = 'production'
}

export interface FeatureFlags {
  employersManagement: boolean;
  implementationForm: boolean;
  enhancedDashboard: boolean;
  groupedNavigation: boolean;
  kyndChoice: boolean;
  pendingEnrollments: boolean;
  whiteLabel: boolean;
}

export interface EnvironmentConfig {
  name: Environment;
  apiUrl: string;
  authEnabled: boolean;
  mockDataEnabled: boolean;
  features: FeatureFlags;
  cognitoPoolId?: string;
  cognitoClientId?: string;
  apiKey?: string;
  adminApiUrl?: string;
}

export const configs: Record<Environment, EnvironmentConfig> = {
  [Environment.DEMO]: {
    name: Environment.DEMO,
    apiUrl: '/mock-api',
    authEnabled: false,
    mockDataEnabled: true,
    features: {
      employersManagement: true,
      implementationForm: true,
      enhancedDashboard: true,
      groupedNavigation: true,
      kyndChoice: true,
      pendingEnrollments: true,
      whiteLabel: true
    }
  },
  [Environment.STAGING]: {
    name: Environment.STAGING,
    apiUrl: process.env.REACT_APP_STAGING_API_URL!,
    authEnabled: true,
    mockDataEnabled: false,
    features: {
      employersManagement: false,
      implementationForm: false,
      enhancedDashboard: false,
      groupedNavigation: true,
      kyndChoice: false,
      pendingEnrollments: false,
      whiteLabel: false
    },
    cognitoPoolId: process.env.REACT_APP_STAGING_COGNITO_POOL_ID,
    cognitoClientId: process.env.REACT_APP_STAGING_COGNITO_CLIENT_ID,
    apiKey: process.env.REACT_APP_STAGING_API_KEY,
    adminApiUrl: process.env.REACT_APP_ADMIN_API_URL
  },
  [Environment.PRODUCTION]: {
    name: Environment.PRODUCTION,
    apiUrl: process.env.REACT_APP_PROD_API_URL!,
    authEnabled: true,
    mockDataEnabled: false,
    features: {
      employersManagement: false,
      implementationForm: false,
      enhancedDashboard: false,
      groupedNavigation: false,
      kyndChoice: false,
      pendingEnrollments: false,
      whiteLabel: false
    },
    cognitoPoolId: process.env.REACT_APP_PROD_COGNITO_POOL_ID,
    cognitoClientId: process.env.REACT_APP_PROD_COGNITO_CLIENT_ID,
    apiKey: process.env.REACT_APP_PROD_API_KEY,
    adminApiUrl: process.env.REACT_APP_ADMIN_API_URL
  }
};

export const getEnvironment = (): Environment => {
  return (process.env.REACT_APP_ENVIRONMENT as Environment) || Environment.PRODUCTION;
};

export const config = configs[getEnvironment()];

// Feature flag utility functions
export const isFeatureEnabled = (featureName: keyof FeatureFlags): boolean => {
  return config.features[featureName];
};

export const getEnabledFeatures = (): Partial<FeatureFlags> => {
  const enabledFeatures: Partial<FeatureFlags> = {};
  Object.entries(config.features).forEach(([key, value]) => {
    if (value) {
      enabledFeatures[key as keyof FeatureFlags] = true;
    }
  });
  return enabledFeatures;
};